import React from 'react';

function formatTime(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  const ss = String(d.getSeconds()).padStart(2, '0');
  const ms = String(d.getMilliseconds()).padStart(3, '0');
  return `${hh}:${mm}:${ss}.${ms}`;
}

function parseUrl(raw = '') {
  try {
    const url = raw.startsWith('http') ? raw : `https://${raw}`;
    const parsed = new URL(url);
    return { host: parsed.host, path: parsed.pathname + parsed.search };
  } catch {
    const slash = raw.indexOf('/');
    if (slash === -1) return { host: raw, path: '' };
    return { host: raw.slice(0, slash), path: raw.slice(slash) };
  }
}

function statusClass(status) {
  if (status == null) return 'net-status--err';
  if (status >= 500) return 'net-status--err';
  if (status >= 400) return 'net-status--warn';
  if (status >= 300) return 'net-status--redir';
  return '';
}

export default function ConsoleHistoryList({ entries, activeEntryId, onSelect }) {
  if (!entries.length) {
    return (
      <div className="net-list">
        <div className="net-list__empty">Send a request to see history</div>
      </div>
    );
  }

  return (
    <div className="net-list">
      <div className="net-list__header">
        <span className="net-col net-col--method">Method</span>
        <span className="net-col net-col--status">Status</span>
        <span className="net-col net-col--url">URL</span>
        <span className="net-col net-col--time">Time</span>
        <span className="net-col net-col--dur">Duration</span>
        <span className="net-list__count">{entries.length} requests</span>
      </div>
      <div className="net-list__body panel-scroll">
        {entries.map((entry) => {
          const { host, path } = parseUrl(entry.url);
          return (
            <button
              key={entry.id}
              type="button"
              className={`net-row${entry.id === activeEntryId ? ' active' : ''}`}
              onClick={() => onSelect(entry.id)}
            >
              <span className="net-col net-col--method">
                <span className={`devtools-method devtools-method--${(entry.method || 'get').toLowerCase()}`}>
                  {entry.method}
                </span>
              </span>
              <span className={`net-col net-col--status ${statusClass(entry.status)}`}>
                {entry.status != null ? entry.status : 'ERR'}
              </span>
              <span className="net-col net-col--url">
                <span className="net-url__host">{host}</span>
                <span className="net-url__path">{path}</span>
              </span>
              <span className="net-col net-col--time">{formatTime(entry.timestamp)}</span>
              <span className="net-col net-col--dur">
                {entry.durationMs != null ? `${entry.durationMs}ms` : '—'}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
